/* eslint-disable no-bitwise */
import countdownLib from 'countdown';
import moment from 'moment';

import Component from '../../../scripts/utilities/component';

class Countdown extends Component {
    componentDidMount() {
        this.cpuDate = moment.utc(this.root.getAttribute('datetime'));

        this.setDisplayTime();
    }

    setDisplayTime() {
        this.timer = countdownLib(
            // new Date(),
            this.cpuDate.toDate(),
            (ts) => {
                let days = '00';
                let hours = '00';
                let minutes = '00';
                let seconds = '00';

                if (ts.value < 0) {
                    days = ts.days.toString().length <= 1 ? `0${ts.days}` : ts.days;
                    hours = ts.hours.toString().length <= 1 ? `0${ts.hours}` : ts.hours;
                    minutes = ts.minutes.toString().length <= 1 ? `0${ts.minutes}` : ts.minutes;
                    seconds = ts.seconds.toString().length <= 1 ? `0${ts.seconds}` : ts.seconds;
                }

                this.markup = `
                    <div class="countdown__inner">
                        <div class="countdown__time-unit">
                            <span class="countdown__time-unit-number">${days}</span>
                            <span class="countdown__time-unit-text">days</span>
                        </div>
                        <div class="countdown__time-unit">
                            <span class="countdown__time-unit-number">${hours}</span>
                            <span class="countdown__time-unit-text">hours</span>
                        </div>
                        <div class="countdown__time-unit">
                            <span class="countdown__time-unit-number">${minutes}</span>
                            <span class="countdown__time-unit-text">mins</span>
                        </div>
                        <div class="countdown__time-unit">
                            <span class="countdown__time-unit-number">${seconds}</span>
                            <span class="countdown__time-unit-text">secs</span>
                        </div>
                    </div>
                `;

                this.root.innerHTML = this.markup;
            },
            countdownLib.DAYS | countdownLib.HOURS | countdownLib.MINUTES | countdownLib.SECONDS
        );
    }
}

export default Countdown;



// WEBPACK FOOTER //
// ./components/eng-ms-countdown/scripts/countdown.js